import {getId} from 'apis/model/base'
import {createValue} from 'components/form/utils'
import React from 'react'
import ContainerPicker from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper, renderBaseOption} from '../../../../components/selectors/BaseSelector'
import useTranslate from "../../../../modules/local/useTranslate";
import {course_class_getCourseClassTimetableDetails_Api} from "../../../../apis";
import getTitle from "../../../../helpers/getTitle";
import {DoubleValueItem} from "../../CatholicHousehold/components/CatholicHouseholdComponents";
import {renderFromToTime} from "../../../../helpers/datetimeHelpers";
import classNames from "classnames";
import {renderIfElse} from "../../../Shared";
import dayjs from "dayjs";
import Pure from "../../../../components/Pure";

export const CourseClassTimetableDetailSelector = ({
                                                       name,
                                                       value,
                                                       subject_id,
                                                       course_class_id,
                                                       course_class_timetable_detail_id,
                                                       onChange = NullAsDefault,
                                                       ...props
                                                   }) => {
    const t = useTranslate();
    const defaultValue = getId(value) ?? value
    return (
        <Pure input={[defaultValue, subject_id, course_class_id, course_class_timetable_detail_id]}>
            <ContainerPicker
                name={name}
                allowClear={true}
                defaultValue={defaultValue}
                type={AppEntities.UNDEFINED}
                placeholder="click to select"
                renderInnerWrapper={InnerWrapper}
                getOption={(option) => option}
                renderOption={renderBaseOption(defaultValue, (option) => {
                    const {subject, start_time, end_time, location_address} = option ?? {}
                    const time = renderFromToTime(start_time, end_time)
                    const is_finish = dayjs(start_time).isBefore(dayjs())


                    return ({
                        title: (
                            renderIfElse(
                                is_finish === true,
                                <span className="font-medium text-color-300 opacity-40">
                                {getTitle(subject)}
                            </span>,
                                getTitle(subject)
                            )
                        ),
                        description: (
                            <DoubleValueItem
                                labelFirst="time"
                                valueFirst={time}
                                labelSecond="in"
                                valueSecond={location_address}
                                className={classNames("text-xs italic", is_finish === true && 'opacity-50')}
                                style={{marginTop: 2}}
                            />
                        ),
                    })
                })}
                onOptionChange={(option) => {
                    onChange(createValue(name, option ?? null))
                }}
                customConfigs={{
                    refreshKey: [subject_id, course_class_id, course_class_timetable_detail_id].join("-"),
                    values: {subject_id, course_class_timetable_detail_id},
                    apiInfo: course_class_getCourseClassTimetableDetails_Api,
                    query: bindQueryParam({id: course_class_id}),
                }}
                {...props}
            />
        </Pure>
    )
}
